export default "__VITE_ASSET__CTLHLLE5__"